import { DraftState } from '@/types';

export const unsetBasketItemIdAction = (draft: DraftState) => {
  delete draft.basketItemId;
};
